import {Link} from 'react-router-dom';
import React, { useContext } from 'react';
import {WebContext} from '../webcontext';
import moment from 'moment';



export default function Chat() {
  const service = useContext(WebContext);
  //console.log(service), 

  

  switch(service.web?.service.template) {
    case 2:
      return (
        <main id="content-area" class="content-area" style={{opacity: 1}}>
          <div data-page-title="Chat">
            <iframe src="https://embed.ultrastream.io/us_OaqUzyhqHMdyVNGLC" id="us_OaqUzyhqHMdyVNGLC" width="100%"></iframe>
          </div>
        </main>
      )
    case 1:
      return (
        <>
        </>
      )
    default:
      return (<></>)
  }

  
}
